var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function ScrollNav($nav, $targets, options) {
  this.$nav = $nav;
  this.$listItems = $nav.find('li');
  this.$targets = $targets;
  this.options = options;

  this.parallax = $('html').hasClass('css-parallax');
  this.$scroll = this.parallax ? $('main') : $(window);

  this.updateMap();

  $(window).on('vsc-page-ready vsc-page-changed vsc-page-resized', function() {
    requestAnimationFrame(this.updateMap.bind(this));
  }.bind(this));

  this.$scroll.on('scroll.vsc-nav-scroll', this.checkScroll.bind(this));

  this.$listItems.on('click', function(event) {
    event.preventDefault();
    var index = $(event.currentTarget).index();
    this.scrollToTarget(this.targetMap[index]);
  }.bind(this));
}

ScrollNav.prototype = {
  updateMap: function() {
    var targetMap = [];

    this.$targets.each(function(index, target) {
      var $target = $(target);

      if($target.is(':visible')) {
        var top = $target.offset().top;
        var height = window.innerHeight;

        if(this.parallax) {
          top += this.$scroll.scrollTop();
        }

        targetMap.push({
          $el: $target,
          top: top,
          height: height,
          scrollTop: top - (height / 2)
        });
      }
    }.bind(this));

    this.targetMap = targetMap;
  },

  checkScroll: function() {
    var activeIndex = 0;
    var scrollY = this.$scroll.scrollTop();

    for(var i = 0; i < this.targetMap.length; i++) {
      var target = this.targetMap[i];
      var $target = target.$el;

      if(!$target.is(':visible')) {
        break;
      }

      if(scrollY >= target.scrollTop) {
        activeIndex = i;
      }
    }

    this.updateLinks(activeIndex);
  },

  updateLinks: function(activeIndex) {
    var $step = this.$listItems.eq(activeIndex);

    if($step.hasClass('inactive')) {
      $step.removeClass('inactive');
    }

    if(!$step.hasClass('current')) {
      $step.trigger('scroll-nav-activate');
    }

    $step.addClass('current').siblings().removeClass('current');
  },

  scrollToTarget: function(t) {
    var $scroll = this.$scroll[0] == window ? $('html,body') : this.$scroll;
    var top = t.top;

    if(this.options && this.options.offset) {
      top += this.options.offset;
    }

    $scroll.animate({
      scrollTop: top
    }, 450);
  }
}

module.exports = ScrollNav;